export type ResponsiveLayout = "S" | "M" | "L" | "XL";

export const getResponsiveLayout = (width: number): ResponsiveLayout => {
  if (width <= 500) {
    return "S";
  } else if (width <= 999) {
    return "M";
  } else if (width <= 1140) {
    return "L";
  } else {
    return "XL";
  }
};
